import { AdTabProps } from "./tab";

enum AdTabsEnum {
  RGCams="RGCams",
  LiveSex="LiveSex",
  SexGames="SexGames",
}

type AdTabsProps = {
  [name in AdTabsEnum]: AdTabProps;
}

export const tabs: AdTabsProps = {
  [AdTabsEnum.RGCams]: {
    label: "RGCams",
    link: "http://go.goaserv.com/redirect.go?pid=390&spaceid=1244529",
  },
  [AdTabsEnum.LiveSex]: {
    label: "Live Sex",
    link: "http://bit.ly/42ukupf",
  },
  [AdTabsEnum.SexGames]: {
    label: "Sex Games",
    link: "https://bit.ly/3Ib5Zw3",
  }
};
